export default {
    'commercial-invoices': 'Facturas comerciales',
    'the-commercial-invoice': 'la factura comercial?',
    'add-a-commercial-invoice': 'Agregar Factura comercial',
    'commercial-invoice': 'Factura Comercial',
}